import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TodayIcon from "@mui/icons-material/Today";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { newDate } from "helpers/dateTools";
import { setReportInventoriesFilters, getReportInventoriesDayAction } from "redux/actions/Reports/reportInventories/reportInventoriesActions";

export const ReportInventoriesDayView = () => {
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportInventories }) => reportInventories);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(getReportInventoriesDayAction({ date, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    dispatch(getReportInventoriesDayAction({ date, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte de inventario detalle del día" icon={<TodayIcon />}>
      {isLoadingComp?.loadingReportInventories ? <LoadingComponent /> :
        <TableInputs
          reducer="reportInventories"
          date
          stations
          maxDate={newDate()}
          dispatchAction={setReportInventoriesFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
